// @flow
import { call, put, takeLatest } from "redux-saga/effects";
import { ActionTypes } from "../constants";
// import { Verify2FASuccess, Verify2FAError } from "../actions/auth2FAActions";
import { request } from "src/helpers/request";
import { Verify2FAError, Verify2FASuccess } from "../actions/authActions";
import { isDevelopment } from "src/module/helpers";

/**
 * Worker Saga: proses kirim OTP ke server
 */
function* verify2FAWorker(action) {
    try {

        // console.log(action)

        const otp = action.otp?.otp;

        // Request ke backend
        const response = yield call(request, "post", "/auth/verify-2fa", {
            otp,
            remember: action?.otp?.remember
        });

        // Jika sukses: kirim action ke redux
        yield put(Verify2FASuccess(response?.data));

        if (response?.data?.token) {
            console.log("Tekan kene token baru")
            localStorage.setItem('authToken', JSON.stringify(response?.data))
        }

        // OPTIONAL:
        // Jika backend memberikan token baru:


        yield put({ type: ActionTypes.SETTING_STATE })

        // yield put({
        //     type: ActionTypes.PROFILE_SET_SUCCESS,
        //     payload: data,
        // })

    } catch (error) {
        if (isDevelopment) {
            console.log(error)
        }
        yield put(Verify2FAError(error?.response?.data || error.message));
    }
}

/**
 * Watcher Saga
 * 
 * 
 */
export default function* watchVerify2FA() {
    yield takeLatest(ActionTypes.VERIFY_2FA, verify2FAWorker);
}
